var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGymnastics = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Gymnastics-Horse--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Gymnastics Horse Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 14.5a1.5 1.5 0 0 0 3 0v-3.95a0.26 0.26 0 0 1 0.13 -0.22 0.28 0.28 0 0 1 0.25 0l3.36 2a1.6 1.6 0 0 0 0.76 0.2H22a1.5 1.5 0 0 0 0 -3h-5.28a0.25 0.25 0 0 1 -0.23 -0.15 0.26 0.26 0 0 1 0.06 -0.28l3.51 -3.51a1.5 1.5 0 0 0 -2.12 -2.12L12.39 9a0.24 0.24 0 0 1 -0.3 0L9.22 7.35a0.25 0.25 0 0 1 -0.12 -0.18 0.23 0.23 0 0 1 0.07 -0.17l4.39 -4.4A1.5 1.5 0 0 0 11.44 0.44L6.9 5A6.49 6.49 0 0 0 5 9.57Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 22a2.5 2.5 0 0 0 -2.5 -2.5h-2.25a0.25 0.25 0 0 0 -0.25 0.25V21a0.5 0.5 0 0 1 -1 0v-3a1 1 0 0 0 -2 0v1.5H8.25a0.25 0.25 0 0 0 -0.25 0.25V21a0.5 0.5 0 0 1 -1 0v-3a1 1 0 0 0 -2 0v1.5H2.5A2.5 2.5 0 0 0 0 22v1.5a0.5 0.5 0 0 0 0.5 0.5h23a0.5 0.5 0 0 0 0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGymnastics);
export default ForwardRef;